export const STATUS = {
	INIT: "init",
	STARTING: "starting",
	READY: "ready",
	LOADING: "loading",
	SUCCESS: "success",
	INVALID: "invalid",
	NOT_FOUND: "not_found",
	ERROR: "error",
	FETCH_ERROR: "fetch_error",
	SCAN_ERROR: "scan_error",
};

export const STATUS_TEXT = {
	init: "Initierar...",
	starting: "Startar kamera...",
	ready: "Rikta kameran mot en streckkod",
	loading: "Söker efter produkt...",
	success: "Streckkod läst",
	invalid: "Ogiltig streckkod",
	not_found: "Ingen produkt hittades",
	error: "Kunde inte starta kameran",
	fetch_error: "Kunde inte hämta produktinformation",
	scan_error: "Kunde inte läsa streckkoden",
};

export const STATUS_CLASS = {
	[STATUS.INIT]: "is-neutral",
	[STATUS.STARTING]: "is-neutral",
	[STATUS.READY]: "is-neutral",
	[STATUS.LOADING]: "is-neutral",
	[STATUS.SUCCESS]: "is-success",
	[STATUS.INVALID]: "is-error",
	[STATUS.NOT_FOUND]: "is-error",
	[STATUS.ERROR]: "is-error",
	[STATUS.SCAN_ERROR]: "is-error",
	[STATUS.FETCH_ERROR]: "is-error",
};

export const LIMIT_MESSAGES = {
	[STATUS.INVALID]: "Streckkoden är ogiltig",
	[STATUS.NOT_FOUND]: "Produkten finns inte i systemet",
	[STATUS.FETCH_ERROR]: "Kunde inte hämta produktinformation",
};
